<template>
<div class="custom-header" ref="custom-header">
  <van-nav-bar :title="titleName" v-if="showNav" placeholder :border="false" @click-left="onClickLeft">
    <template #left>
      <van-icon name="arrow-left" size="18" color="#333" />
    </template>
    
  </van-nav-bar>
  <!--  :style="{ position: showUser ? 'fixed' : 'relative', left: 0, top: 0 }" -->
  <div class="header">
    <img :src="$store.state.plat.logo" @click="toPage('./index')"/>
    <div class="search" @click="goSearch">
      <img class="icon" src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/search_icon.png" alt="" />
      <span>搜索课程</span>
    </div>
    <div class="user-center" v-if="isLogin" @click="toPage('./userYingyou/center')">
      <!-- <p>个人</p>
      <p>中心</p> -->
      <img :src="userImg"/>
    </div>
    <div class="user-center" v-else @click="toPage('./login/phone')">
       <!-- 登录/注册 -->
       <img :src="userImg"/>
    </div>
  </div>
  <div class="index-tab-header" id="tab">
    <van-tabs  color="#000000" title-inactive-color="#999999" title-active-colo="#000" line-width="16" v-model="activeName" :ellipsis="false" :before-change="onChange">
      <van-tab :title="item.category_name" v-for="(item, index) of indexTab" :key="index"></van-tab>
    </van-tabs>
  </div>
</div>
</template>

<script>
export default {
  props: {
    showUser: {
      type: Boolean,
    },
    showNav: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      userImg:'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/H5/%E4%B8%AA%E4%BA%BA%E4%B8%AD%E5%BF%83.png',
      indexTab:[{
        category_name:' 推荐',
        url: './index',
      },
      // {
      //   category_name:' 直播',
      //   url: './live',
      // },
      {
        category_name:' 育儿学堂',
        url: '../jiazhang06/index',
      }],
      activeName: 0,
    };
  },
  mounted() {
    
    this.$store.commit("SET_HEADER_HEIGHT", this.$refs['custom-header'].offsetHeight);
    this.getCat()
    

  },
  computed: {
    isLogin(){
      return localStorage.getItem('token') ? true : false
    },
    // activeName: {
    //   get() {
    //     return this.$store.state.headerActive;
    //   },
    //   set(value) {
    //     return this.$store.headerActive;
    //   },
    // },
    titleName() {
      return this.$store.state.plat.name;
    },
    plat() {
      return this.$store.state.plat_id;
    },    
  },
  methods: {
    getCat(){

      this.$request.tuoyuCategory2({ flat_id: this.plat }).then((res) => {
        console.log(this.plat )
        if(this.plat == '107'){
          let item = res.data.find(i=>i.category_name.indexOf('职业能力')>-1)
          this.indexTab = [{
            category_name:' 推荐',
            url: './index',
          },{
            category_name:' VIP课程',
            url: './vipLesson',
          },{
            category_name:' 职业能力认证',
            category_id:item.category_id
          },{
            category_name:' 直播',
            url: './live',
          }]
        }else if(this.plat == '119'){
            this.indexTab.splice(1,1,{
              category_name:'托育相关政策法规培训',
              url: './lessonYingyou?id=208',
              category_id: 208
            },{
              category_name:' 托育机构负责人培训',
              url: './lessonYingyou?id=230',
            },{
              category_name:'托育机构保育人员培训',
              url: './lessonYingyou?id=231',
              category_id: 231
            },
            {
              category_name:'托育机构岗位职责培训',
              url: './lessonYingyou?id=207',
              category_id: 207
            },
            /*
            {
              category_name:'机构负责人技能提升培训',
              url: './lessonYingyou?id=228',
            },{
              category_name:'保育人员技能提升培训',
              url: './lessonYingyou?id=229',
              category_id: 229
            },*/
            {
              category_name:'托育服务技能实训',
              url: './lessonYingyou?id=226',
              category_id: 226
            },
            {
              category_name:'托育从业人员职业发展',
              url: './lessonYingyou?id=122',
              category_id: 122
            },
            {
              category_name:'托育服务专项培训',
              url: './lessonYingyou?id=163',
              category_id: 163
            },
           {
              category_name:'往期直播',
               url: './live',
          })
          
        }else if(this.plat == '171'){
            this.indexTab.splice(1,0,...res.data.filter(item=>item.category_id!=226),{
              category_name:' 幼儿园、托育机构线上招生攻略',
              url: './detailYingyou?id=713',
            })
        }else{
          this.indexTab.splice(1,0,...res.data)
        }
        
        let activeName = 0
        if(this.$route.query.id){
          activeName = this.indexTab.findIndex(item=> item.category_id && item.category_id == this.$route.query.id)
        }else{
          activeName = this.indexTab.findIndex(item=> item.url && item.url.indexOf(this.$route.path.split('/').pop())!=-1)
        }
        console.log('==========',activeName)
        this.$nextTick(()=>{
          this.activeName = activeName
        })
        // this.$store.commit("SET_HEADER", activeName);
      });
    },
    toPage(url){
      this.$router.push(url);
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    goSearch() {
      this.$router.push(`./SearchYingyou`);
    },
    onChange(name) {
      this.$store.commit("SET_HEADER", name);
      this.activeName = name
      if(this.indexTab[name].url){
        this.$router.push(this.indexTab[name].url);
      }else{
        this.$router.push(`./lessonYingyou?id=${this.indexTab[name].category_id}`);
      }
      // this.$router.push(`./${name}`);
      return false;
    },
  },
  watch: {
    $route(newval, oldval) {
      console.log("this.$store.state", newval, oldval, this.$store.state.headerActive);
      
      this.$store.commit("SET_HEADER_HEIGHT", this.$refs['custom-header'].offsetHeight);
      
    },
    activeName(val){
      console.log('activeName:',val)
    }
  },
};
</script>

<style scoped lang="scss">

.index-tab-header {
  /* top: 96px; */
}

.custom-header {
  width: 100%;
  overflow: hidden;
  background: #fff;
  position: relative;
  z-index: 999;
  /* height: 90px; */
  position: fixed;
  left: 0;
  top: 0;
}

.header {
  width: 100vw;
  height: 96px;
  display: flex;
  align-items: center;
  background: #fff;
  z-index: 99;
  
}
.header >img{
    margin-left: 30px;
    max-height: 100%;
    max-width: 378px;
  }

.search {
  flex: 1;
  border-radius: 33px;
  height: 66px;
  background: #f0f2f8;
  font-size: 28px;
  font-weight: 400;
  color: #9fa2b3;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 30px;
}

.icon {
  width: 31px;
  height: 31px;
  margin-right: 20px;
}

.user-center {
  // flex: 0 0 118px;
  // width: 118px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #555;
  font-size: 26px;
  line-height: 30px;
  padding: 0 20px;
  img{
    width: 50px;
    height: 50px;
  }
}
</style>>
